import { lazy } from "react";

/**
 * Wrap React.lazy for route components with default-export dynamic imports.
 * Usage: const LazyPage = lazyRoute(() => import("views/SomePage"));
 *        <Route path="/some-page" component={LazyPage} />
 */
export const lazyRoute = (importFn) =>
  lazy(() =>
    importFn().then((module) => ({
      default: module.default ?? module,
    }))
  );

/** Warm a lazy route chunk before navigation (e.g. after login). */
export const preloadLazyRoute = (importFn) => {
  importFn();
};
